import apiClient from "../apiClient";
import { CommonApiResponse } from "../../Controllers/Types/ApiResponse";
import { baseURL } from "../ApiConstant";

// get use case user types
export const getUsecaseUserTypes = async () => {
    try {
        const response = await apiClient.get(`/api/usecase-usertype-list`);

        if (response.status === 200) {
            return { status: true, body: response.data };
        } else {
            return { status: false, error: "failed" };
        }
    } catch (error: any) {
        console.error("Error fetching data:", error);

        return {
            status: false,
            error: "An error occurred. Please try again later.",
        };
    }
};

// get use case modules
export const getUsecaseModules = async () => {
    try {
        const response = await apiClient.get(`/api/usecase-module-list`);

        if (response.status === 200) {
            return { status: true, body: response.data };
        } else {
            return { status: false, error: "failed" };
        }
    } catch (error: any) {
        console.error("Error fetching data:", error);

        return {
            status: false,
            error: "An error occurred. Please try again later.",
        };
    }
};

// Send chat message
export const sendChatMessageAPI = async (
    full_name: string,
    phone_number: string,
    email: string,
    message: string,
): Promise<CommonApiResponse> => {
    try {
        /* create form data */
        const formData = new FormData();

        formData.append("full_name", full_name);
        formData.append("phone_number", phone_number);
        formData.append("email", email);
        formData.append("message", message);

        const response = await fetch(
            `${baseURL}/api/chat-email-send`,
            {
                method: "POST",
                headers: {
                    Accept: "application/json",
                },
                body: formData,
            }
        );

        const data = await response.json();

        if (response.status === 200) {
            return {
                status: true,
                statusCode: 200
            };
        } else if (response.status === 401) {
            return {
                status: false,
                statusCode: 401,
                massage: "Unauthorized"
            };
        } else if (response.status === 422) {
            return {
                status: false,
                statusCode: 422,
                errors: data["errors"],
                massage: "Body error",
            };
        } else if (response.status === 404) {
            return {
                status: false,
                statusCode: 404,
                massage: "Not found"
            };
        } else {
            return {
                status: false,
                statusCode: 500,
                massage: "Error"
            };
        }
    } catch (error) {
        throw error;
    }
};

// Send contact us message
export const sendContactUsMessageAPI = async (
    first_name: string,
    last_name: string,
    phone_number: string,
    subject: string,
    message: string,
): Promise<CommonApiResponse> => {
    try {
        /* create form data */
        const formData = new FormData();

        formData.append("first_name", first_name);
        formData.append("last_name", last_name);
        formData.append("phone_number", phone_number);
        formData.append("subject", subject);
        formData.append("message", message);

        const response = await fetch(
            `${baseURL}/api/contact-us-email-send`,
            {
                method: "POST",
                headers: {
                    Accept: "application/json",
                },
                body: formData,
            }
        );

        const data = await response.json();

        if (response.status === 200) {
            return {
                status: true,
                statusCode: 200
            };
        } else if (response.status === 401) {
            return {
                status: false,
                statusCode: 401,
                massage: "Unauthorized"
            };
        } else if (response.status === 422) {
            return {
                status: false,
                statusCode: 422,
                errors: data["errors"],
                massage: "Body error",
            };
        } else if (response.status === 404) {
            return {
                status: false,
                statusCode: 404,
                massage: "Not found"
            };
        } else {
            return {
                status: false,
                statusCode: 500,
                massage: "Error"
            };
        }
    } catch (error) {
        throw error;
    }
};

// Book demo email
export const sendBookDemoEmailAPI = async (
    email: string,
): Promise<CommonApiResponse> => {
    try {
        /* create form data */
        const formData = new FormData();

        formData.append("email", email);

        const response = await fetch(
            `${baseURL}/api/free-demo-email-send`,
            {
                method: "POST",
                headers: {
                    Accept: "application/json",
                },
                body: formData,
            }
        );

        const data = await response.json();

        if (response.status === 200) {
            return {
                status: true,
                statusCode: 200
            };
        } else if (response.status === 401) {
            return {
                status: false,
                statusCode: 401,
                massage: "Unauthorized"
            };
        } else if (response.status === 422) {
            return {
                status: false,
                statusCode: 422,
                errors: data["errors"],
                massage: "Body error",
            };
        } else if (response.status === 404) {
            return {
                status: false,
                statusCode: 404,
                massage: "Not found"
            };
        } else {
            return {
                status: false,
                statusCode: 500,
                massage: "Error"
            };
        }
    } catch (error) {
        throw error;
    }
};